import client from './client';

// ---------------------------------------------------------------------------
// Tipi condivisi (rispecchiano i data contracts del backend)
// ---------------------------------------------------------------------------

export interface SpatialLocation {
  x: number;
  y: number;
}

export interface SpottedEvent {
  event_id: string;
  type: string; // "serve" | "pass" | "set" | "attack" | "block" | "dig" | "free_ball" | "tip"
  timestamp_ms: number;
  player_id: number;
  team: string; // "A" | "B"
  spatial_location: SpatialLocation;
  confidence: number;
}

export interface Rally {
  rally_id: string;
  start_timestamp_ms: number;
  end_timestamp_ms: number;
  events: SpottedEvent[];
  score: { A: number; B: number };
  winning_team: string; // "A" | "B"
  rotation: { A: number[]; B: number[] };
}

export interface PlayerStats {
  kills: number;
  errors: number;
  aces: number;
  blocks: number;
  digs: number;
  points: number;
  attack_attempts: number;
  serve_attempts: number;
}

export interface StatsData {
  player_stats: Record<number, PlayerStats>;
}

export interface ResultsResponse {
  video_id: string;
  status: string; // "completed" o "failed" o "processing"
  rallies: Rally[];
  stats: StatsData;
}

export interface JobResponse {
  id: string;
  video_id: string;
  status: string;
  pipeline_state: Record<string, unknown> | null;
  error_message: string | null;
  retry_count: number;
  created_at: string;
  started_at: string | null;
  completed_at: string | null;
  updated_at: string;
}

// ---------------------------------------------------------------------------
// API Calls
// ---------------------------------------------------------------------------

/**
 * Recupera i risultati completi dell'analisi per un video.
 */
export async function getResults(videoId: string): Promise<ResultsResponse> {
  const response = await client.get<ResultsResponse>(`/results/${videoId}`);
  return response.data;
}

/**
 * Crea un nuovo job di elaborazione per un video.
 */
export async function createJob(videoId: string): Promise<JobResponse> {
  const response = await client.post<JobResponse>('/jobs/', {
    video_id: videoId,
  });
  return response.data;
}

/**
 * Recupera lo stato di un job.
 */
export async function getJobStatus(jobId: string): Promise<JobResponse> {
  const response = await client.get<JobResponse>(`/jobs/${jobId}`);
  return response.data;
}

/**
 * Recupera il job più recente per un video.
 */
export async function getJobByVideo(videoId: string): Promise<JobResponse> {
  const response = await client.get<JobResponse>(`/jobs/by-video/${videoId}`);
  return response.data;
}